export default {"src":"/_next/static/media/eye-slash.7d97e440.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};